import React from 'react'
import PageLayout from '../pagelayout';
import Map from "../Map/map"
import Tabs from './tabs';
import { UpcomingOrders, CompletedOrders } from './storeorder';

const tabs = [
    {
        name: "Ongoing orders",
        component: <UpcomingOrders />
    },
    {
        name: "Completed orders",
        component: <CompletedOrders />
    }
];


const StoreOrdersPage = () => (
    <PageLayout Map={Map}>
        <Tabs tabs={tabs} />
    </PageLayout>
)

export default StoreOrdersPage
